import {
  Modal,
  ModalBody,
  ModalHeader,
  ModalContent,
} from '@heroui/react';
import React from 'react';
import Button from 'ui/button';
import { SamsaraLogo } from 'icons/brand/samsara';
import microsoftLogo from '../../../assets/brand-logos/microsoft.png';

export type SSOProvider = {
  id: string;
  name: string;
  icon: React.ReactNode;
  onClick: () => void;
};

type SSOModalProps = {
  isOpen: boolean;
  onClose: () => void;
  providers: SSOProvider[];
  title?: string;
  subtitle?: string;
};

const SSOModal = ({
  isOpen,
  onClose,
  providers,
  title = 'Sign in with SSO',
  subtitle = 'Choose your identity provider',
}: SSOModalProps) => {
  return (
    <Modal
      classNames={{ closeButton: 'rounded-md' }}
      isOpen={isOpen}
      onClose={onClose}
      size="sm"
    >
      <ModalContent className="p-6 rounded-xl">
        {(onClose) => (
          <>
            <ModalHeader className="p-0 m-0 flex flex-col gap-1">
              <span className="font-semibold text-xl text-primary-text-color">
                {title}
              </span>
              <span className="font-light text-sm text-default-500">
                {subtitle}
              </span>
            </ModalHeader>
            <ModalBody className="p-0 m-0 mt-6">
              <div className="flex flex-col gap-3">
                {providers.map((provider) => (
                  <Button
                    key={provider.id}
                    fullWidth
                    variant="bordered"
                    color="default"
                    onClick={() => {
                      provider.onClick();
                      onClose();
                    }}
                    className="justify-start px-4 py-6"
                    aria-label={`Sign in with ${provider.name}`}
                    startContent={provider.icon}
                  >
                    <span className="ml-2">{provider.name}</span>
                  </Button>
                ))}
              </div>
            </ModalBody>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

// Pre-configured SSO provider icons
export const SSOIcons = {
  EnumerateMicrosoft: () => (
    <img
      src={microsoftLogo.src}
      alt="Enumerate Microsoft logo"
      width={20}
      height={20}
    />
  ),
  Samsara: () => <SamsaraLogo width={20} height={20} />,
};

export default SSOModal;
